module.exports = __webpack_public_path__ + "img/product_25.11fd129.jpg";